import {colors} from '@material-ui/core';
import {Palette, PaletteColor, PaletteColorOptions, PaletteOptions} from '@material-ui/core/styles/createPalette';

const white = '#FFFFFF';
const black = '#000000';

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    icon: string;
    black: string;
    white: string;
    neutral: string;
    success: PaletteColor;
    info: PaletteColor;
    warning: PaletteColor;
    cta: string;
  }
  // allow configuration using `createMuiTheme`
  interface PaletteOptions {
    icon?: string;
    black?: string;
    white?: string;
    neutral?: string;
    success?: PaletteColorOptions;
    info?: PaletteColorOptions;
    warning?: PaletteColorOptions;
    cta?: string;
  }
  interface TypeText {
    link? :string,
  }
}

export const palette: PaletteOptions = {
  black,
  white,
  neutral: colors.grey[200],
  primary: {
    contrastText: white,
    dark: '#00006d',//colors.indigo[900],
    main: '#30009d',//colors.indigo[500],
    light: '#6a36cf',//colors.indigo[100]
  },
  secondary: {
    contrastText: white,
    dark: '#790074',//colors.blue[900],
    main: '#6101AD',//colors.blue['A400'],
    light: '#8651b1',//colors.blue['A400']
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  background: {
    default: '#f2f2f2',
    paper: white
  },
  divider: colors.grey[200],
  icon: colors.blueGrey[600],
  cta: '#30129D',
};

export default palette;